import React from 'react';
import Logo from '../ui/Logo';
import { Phone, Mail } from 'lucide-react';

const footerLinks = {
  Produit: ['Fonctionnalités', 'Tarifs', 'Témoignages', 'FAQ', 'Changelog'],
  Entreprise: ['À propos', 'Blog', 'Carrières', 'Presse', 'Partenaires'],
  Support: ['Centre d\'aide', 'Documentation', 'Contact', 'Statut', 'WhatsApp'],
};

export default function Footer() {
  return (
    <footer className="bg-dark-footer border-t border-white/5">
      {/* Orange gradient separator */}
      <div className="h-px bg-gradient-to-r from-transparent via-primary/50 to-transparent" />

      <div className="max-container px-4 sm:px-6 lg:px-8 py-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Brand */}
          <div>
            <Logo className="mb-4" />
            <p className="text-gray-400 text-sm leading-relaxed mb-4">
              Gérez mieux. Gagnez plus. Vivez mieux.
            </p>
            <div className="flex flex-col gap-2 mb-4">
              <a
                href="https://wa.me/221788752020?text=Bonjour%2C%20je%20suis%20int%C3%A9ress%C3%A9%20par%20XamXamBoutik"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 text-primary hover:text-primary/80 transition-colors text-sm font-medium"
              >
                <Phone size={16} />
                +221 78 875 20 20
              </a>
              <a
                href="mailto:support@xamxamboutik.com"
                className="inline-flex items-center gap-2 text-primary hover:text-primary/80 transition-colors text-sm font-medium"
              >
                <Mail size={16} />
                support@xamxamboutik.com
              </a>
            </div>
            <p className="text-gray-500 text-xs">
              Conçu en Afrique, pour l'Afrique
            </p>
          </div>

          {/* Link columns */}
          {Object.entries(footerLinks).map(([title, links]) => (
            <div key={title}>
              <h4 className="text-white font-semibold mb-4">{title}</h4>
              <ul className="space-y-3">
                {links.map((link) => (
                  <li key={link}>
                    <button
                      type="button"
                      className="text-gray-400 text-sm hover:text-primary transition-colors"
                    >
                      {link}
                    </button>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Bottom */}
        <div className="mt-8 pt-6 border-t border-white/5 flex flex-col sm:flex-row items-center justify-between gap-4">
          <div className="flex flex-col gap-1">
            <p className="text-gray-500 text-sm">
              &copy; 2026 SO ALASSANA (SaaSinnova BrainTech) — NINEA : 007259147 | RCCM : SN DKR 2019 A 7248
            </p>
            <p className="text-gray-500 text-sm">
              Keur Massar, Pikine, Sénégal — Conçu en Afrique, pour l'Afrique
            </p>
          </div>
          <div className="flex gap-6">
            <button type="button" className="text-gray-500 text-sm hover:text-primary transition-colors">
              Conditions
            </button>
            <button type="button" className="text-gray-500 text-sm hover:text-primary transition-colors">
              Confidentialité
            </button>
          </div>
        </div>
      </div>
    </footer>
  );
}
